import { Box, Stack, Typography } from "@mui/material";
import React from "react";

export const HubChartLabel = ({
  color,
  label,
  LabelProps = {},
  StackProps = {},
  isDashLine = false,
}) => {
  return (
    <Stack
      direction="row"
      gap="10px"
      alignItems="center"
      justifyContent="start"
      {...StackProps}
    >
      {isDashLine ? (
        <Typography fontSize={10} fontWeight={900} color={color}>
          ---
        </Typography>
      ) : (
        <Box
          width="10px"
          height="10px"
          borderRadius="3px"
          backgroundColor={color}
        />
      )}
      <Typography {...LabelProps}>{label}</Typography>
    </Stack>
  );
};

export default HubChartLabel;
